module.exports = {"title":"Uživatelský účet","button.close":"Zavřít"}